<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Quiz Type</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="quiz_type_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Quiz Type</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="quiz_type_super_master_list"
                          v-model="addedItem.quiz_type" label="Select Quiz Type"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.quiz_type" dense rounded outlined persistent-hint
                          :disabled="editedIndex != -1" :hint="
                            editedIndex == -1
                              ? 'For example :: MCQ, Subjective'
                              : 'noneditable'
                          " label="Quiz Type"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.display_name" dense rounded outlined persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: MCQ, Subjective'
                              : ''
                          " label="Quiz Type"></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" sm="12" md="12">
                    <v-select :items="quiz_type_super_master_list"
                    v-model="editedItem.feesComponent" 
                    persistent-hint
                    :disabled="editedIndex != -1"
                    :hint="editedIndex==-1?'For example :: Tution Fees, Development Fees':'noneditable'"
                    :filled="editedIndex==-1?false:true"
                    label="Enter Fees Component"
                    :error="errorMsg.feesComponent?true:false"
                    :error-messages="errorMsg.feesComponent?'Required':''"
                    >
                    </v-select>
                  </v-col> -->
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <!-- <template v-slot:item.compulsory="{ item }">
          <v-switch
            inset
            v-model="item.compulsory"
            :color="item.compulsory ? 'success' : 'primary'"
            @change="toggle(item)"
          ></v-switch>
        </template> -->

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Quiz Type Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",

    errorMsg: {
      quiz_type: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    quiz_type_super_master_list: null,
    headers: [
      {
        text: "Quiz Type",
        align: "left",
        sortable: false,
        value: "quiz_type",
      },
      {
        text: "Display Name",
        align: "left",
        sortable: true,
        value: "display_name",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    quiz_type_list: [],
    editedIndex: -1,
    addedItem: {
      quiz_type: null,
    },
    editedItem: {
      id: "",
      quiz_type: "",
      display_name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      quiz_type: "",
      display_name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Quiz Type"
        : "Edit Quiz Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.quiz_type = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/QuizQuestionBank/quizType")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.quiz_type_super_master_list =
              res.data.quiz_type_super_master_list;
            this.quiz_type_list = res.data.quiz_type_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.quiz_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.quiz_type_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.quiz_type_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post(
              "/QuizQuestionBank/editQuizType",
              this.editedItem
            )
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.quiz_type_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Quiz Type updated successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
              this.showSnackbar(
                  "#b71c1c",
                  "Something went wrong!!!"
                );
            })
            .finally(() => {
              this.addedItem.quiz_type = null
            });

          this.close();
        }
      } else {
        axios
          .post("/QuizQuestionBank/saveQuizType", this.addedItem)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.quiz_type_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                 "Quiz Type added successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.flag == "NO") {
              this.showSnackbar(
                "#b71c1c",
                res.data.snackbar_msg
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar(
                  "#b71c1c",
                  "Something went wrong!!!"
                );
          })
          .finally(() => {
              this.addedItem.quiz_type = null
            });

        this.close();
      }
    }, // end of save()

    // toggle(item){
    //  // alert(item.id)
    //   const data = {
    //     fees_component_id : item.id,
    //     fees_component_compulsory : item.compulsory
    //   }
    //   axios
    //     .post("/AccountingAndFees/toggleFeesComponentCategory", data)
    //     .then((res) => {
    //       if (res.data.flag == "YES") {
    //         this.showSnackbar(
    //           "#4caf50",
    //           "Fees Component Category status updated successfully..."
    //         );
    //       }else{
    //         this.showSnackbar("#b71c1c", "Can't update Fees Component Category status!!!");
    //       }
    //     })
    //     .catch((error) => {
    //       this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
    //     })
    //     .finally(() => {
    //       //overlay->loader
    //     });
    // },

    isValidated() {
      if (this.editedItem.quiz_type) {
        return true;
      } else {
        if (!this.editedItem.quiz_type) {
          this.errorMsg.quiz_type = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
